import { ErrorFault } from "./ErrorFault";

export interface ErrorFaultStateModel {
    errorFault: ErrorFault | null;
    errorFaults: ErrorFault[];
    addError : (errorFault: ErrorFault) => void;
    removeError  : (errorFault: ErrorFault) => void;
  }

  export const initialErrorFaultState: ErrorFaultStateModel = {
    errorFault : null,
    errorFaults: [],
    addError : () => undefined,
    removeError : () => undefined
  };